import type {
	DashboardGoalsSlide,
	DashboardSlide,
} from "web_myplann/Dashboard/Types/DashboardSlide";

export const isGoalsSlide = (
	slide: DashboardSlide,
): slide is DashboardGoalsSlide => "goalOverview" in slide;
